import { Swiper } from 'swiper/bundle';

const swipers = document.querySelectorAll('.js-events-swiper');

swipers.forEach((swiperInstance) => {
  initializeSwiper(swiperInstance);
});

function initializeSwiper(swiperInstance) {
  const slides = swiperInstance.querySelectorAll('.generic-card');
  slides.forEach((slide) => {
    slide.classList.add('swiper-slide');
  });

  const swiper = new Swiper(swiperInstance, {
    slidesPerView: '1',
    watchOverflow: true,
    watchSlidesProgress: true,
    spaceBetween: 24,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next > button',
      prevEl: '.swiper-button-prev > button',
    },
    breakpoints: {
      992: {
        slidesPerView: '2',
      },
    },
    a11y: {
      firstSlideMessage: 'Dit is de eerste slide',
      nextSlideMessage: 'Naar de volgende slide',
      prevSlideMessage: 'Naar de vorige slide',
      lastSlideMessage: 'Dit is de laatste slide',
      paginationBulletMessage: 'Ga naar slide {{index}}',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });

  slides.forEach((slide, index) => {
    slide.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });
}

export { initializeSwiper };
